var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kstmod-rtnreceive-relatedlist"},[_c('Rows',{attrs:{"access":_vm.access,"dataList":_vm.dataList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }